export const apiUrl="https://www.danicos.ro/api"